var React = require('react');

function IconVerticalArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 5L5 1L1 5","stroke":"#0088BF","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

IconVerticalArrow.defaultProps = {"width":"10","height":"6","viewBox":"0 0 10 6","fill":"none"};

module.exports = IconVerticalArrow;

IconVerticalArrow.default = IconVerticalArrow;
